import { Component } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoaderService } from './core/services/loader.service';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
  imports: [RouterOutlet, CommonModule]
})
export class AppComponent {
  title = 'knab-payment-requests-web';

  constructor(
    public loaderService: LoaderService,
    private router: Router
  ) {
    if (environment.launchMobileConsole) {
      //for debugging and testing on mobile devices
      import('eruda').then((eruda) => eruda.default.init());
    }
    // show loader for other routes navigation start
    this.router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationStart) {
        this.loaderService.showLoader();
      }
    });
  }
}
